export type TyLink = {
  title: string;
  label: string;
  href: string;
  isRegionHeaderLink: boolean;
  showOnlyAfterLogin: boolean;
  isExternal?: boolean;
};

export type TyNavMenuMap = { [name: string]: TyLink[][] };

//export type TyRegion = 'SOUTHERN-CALIFORNIA' | 'NORTHERN-CALIFORNIA';
export type TyRegion = 'SOUTHERN-CALIFORNIA' | 'NORTHERN-CALIFORNIA';
export enum ERegionBasic {
  SCAL = 'SCAL',
  NCAL = 'NCAL',
}

export enum ERegionBasicLowercase {
  scal = 'scal',
  ncal = 'ncal',
}

export enum ImageHostName {
  CONTENTSTACK = "images.contentstack.io",
  KPSTORE = "store.kaiserpermanente.org"
}

export type TyRegionBasic = keyof typeof ERegionBasic;
export type TyRegionBasicLowecase = keyof typeof ERegionBasicLowercase;

export type TyRegionMessages = { [key: string]: string };

export type ISiteLogo = {
  url: string;
};

export type INotification = {
  notificationProps?: Array<object>;
};

export type INotificationdata = {
  isenabled?: boolean;
  json_rte?: JSON;
};

export type TySwipeDirection = 'RIGHT' | 'LEFT' | 'UP' | 'DOWN';

export type TySwipeEventData = {
  absX: number;
  absY: number;
  deltaX: number;
  deltaY: number;
  dir: TySwipeDirection;
  event: TouchEvent | MouseEvent;
  vxvy: number[];
  mDeltaX: number;
  mDeltaY: number;
};

export const SiteMapDialogAction = {
  ONE_TRUST: 'one_trust',
};
